import { InputFilterTrigger } from '@src/shared/features/views/components/static-filter-inputs';
import { leadDuplicatesFilterConfig } from '../../../configs/lead-duplicates-filter-config';

export const LeadDuplicatesFilter = () => {
  return (
    <InputFilterTrigger
      filterLabel='Duplicates'
      config={leadDuplicatesFilterConfig}
    />
  );
};
